<template>
  <div class="form-floating mb-3">
    <input
        @input="handleInput"
        :type="type"
        class="form-control"
        :id="property"
        :value="value"
        :class="{'is-invalid': error }"
        :disabled="disabled"
    >
    <label :for="property">{{ name }}<span class="text-danger" v-if="isRequired">*</span></label>
  </div>
</template>

<script>
export default {
  name: 'HiddenField',
  props: {
    value:{}, 
    property:{ type: String }, 
    name:{ type: String }, 
    type:{ type: String, default: 'hidden' }, 
    error:{ type: Boolean }, 
    disabled:{ type: Boolean, default: false}, 
    isRequired:{ type: Boolean }
  }
  ,
  methods: {
    handleInput (e) {
      this.$emit('input', e.target.value)
    }
  }
}
</script>

<style scoped>
input{
  border-radius: 0 !important;
}
</style>
